// extracted by mini-css-extract-plugin
export default {"modalTitle":"Lightbox_modalTitle__2sTt3","closeBtn":"Lightbox_closeBtn__KATUM"};